import { ResetStateType } from '../../types';

const resetState: ResetStateType = (stateProperty, initialState) => (state) => {
  state[stateProperty] = initialState;
};

export default resetState;
